import localforage from 'localforage';

import { GET_PLAYLIST_ITEMS } from '../actions/playlist';
import { SET_PLAYLIST_CHILDREN } from '../actions/player';
import { cacheData } from '@/helpers/caching';
import { buildPlaylistItemsMap } from '@/helpers/utils';

import { apiGetScreenPlaylistItem } from '../../api/playlist';

const state = {
  playlists: [],
};

const getters = {};

const actions = {
  [GET_PLAYLIST_ITEMS]: async ({ commit, rootState }, { playlistId, assocId }) => {
    const { screenId } = rootState.player;
    const { isAppOnline } = rootState.offline;

    try {
      const response = isAppOnline
        ? await apiGetScreenPlaylistItem(playlistId, screenId, false)
        : null;

      if (!response) {
        const playlistItems = await localforage.getItem(`playlist-items-${playlistId}-${assocId}`);

        if (!playlistItems)
          throw new Error(`Playlist's items cache fallback failed. Playlist: ${playlistId}`);

        commit(SET_PLAYLIST_CHILDREN, { playlistItems, assocId }, { root: true });
        return;
      }

      const data = response.data;

      if (!data.items) throw new Error(data);

      const playlistItems = buildPlaylistItemsMap(data);

      await cacheData(`playlist-items-${playlistId}-${assocId}`, playlistItems);

      commit(SET_PLAYLIST_CHILDREN, { playlistItems, assocId }, { root: true });
    } catch (error) {
      console.log('error: ', error?.message);
    }
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
